var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarTrustpilotHalf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_1",
    className: "tp-star"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_2",
    d: "m1.75746,46.85724l46.376,0l0,-49.14195l-46.376,0l0,49.14195z",
    fill: "#dcdce6",
    className: "tp-star__canvas"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_21",
    height: 73.46211,
    width: 67.66248,
    y: -14.43404,
    x: -44.48673,
    fill: "#00b67a"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_3",
    fill: "#FFF",
    d: "m39.35825,19.711l-26.304,19.09l3.838,-11.798l-10.047,-7.293l12.42,0l3.837,-11.798l3.837,11.798l12.419,0l0,0.001zm-16.255,11.8l7.183,-1.511l2.862,8.8l-10.045,-7.29l0,0.001z",
    className: "tp-star__shape"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarTrustpilotHalf);
export default __webpack_public_path__ + "static/media/star_trustpilot_half.17ce70dfc0fd6e14c2b162d024e331fe.svg";
export { ForwardRef as ReactComponent };